import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import PackageCard from '../components/PackageCard';
import SuccessStories from '../components/SuccessStories';
import TrustBadges from '../components/TrustBadges';
import LearnToDriveWithUs from '../components/LearnToDriveWithUs';
import { ArrowRight, Check } from 'lucide-react';
const HomePage = () => {
  // Featured packages for homepage
  const standardPackages = [{
    title: 'Trial 1st Session',
    price: '£40',
    description: 'Try a one-hour lesson with no obligation.',
    features: ['Meet your instructor', 'Initial driving assessment', 'Personalised learning plan'],
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: '6 Hour Package',
    price: '£225',
    originalPrice: '£240',
    description: '£37.50 per hour - Master the basics and prepare for your test.',
    features: ['Save £15 on standard pricing', 'Behind-the-wheel training', 'Traffic rules and regulations'],
    popular: true,
    saving: '£15',
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: '20 Hour Package',
    price: '£710',
    originalPrice: '£800',
    description: '£35.50 per hour - Full training for complete beginners.',
    features: ['Save £90 on standard pricing', 'Full driving skills coverage', 'Test preparation'],
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }];
  const intensivePackages = [{
    title: '20 Hour Intensive',
    price: '£910',
    originalPrice: '£1000',
    description: '£45.50 per hour - Accelerated training for test-ready drivers.',
    features: ['Save £90 on standard pricing', 'Accelerated learning', 'Ideal for quick test preparation'],
    saving: '£90',
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: '34 Hour Intensive',
    price: '£1,496',
    originalPrice: '£1,700',
    description: '£44 per hour - Our most complete package for beginners.',
    features: ['Save £204 on standard pricing', 'Complete driver training', 'Fast-track to test readiness'],
    popular: true,
    saving: '£204',
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }];
  const additionalPackages = [{
    title: 'Refresher Lessons',
    price: '£90',
    description: '£45 per hour - Rebuild your confidence on the road.',
    features: ['2 hours of focused training', 'Experienced instructors', 'Personalised to your needs'],
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: 'Motorway Lessons',
    price: '£90',
    description: '£45 per hour - Gain confidence on high-speed roads.',
    features: ['2 hours of motorway practice', 'Safe environment to learn', 'Essential skills for all drivers'],
    popular: true,
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: 'Test Booking Service',
    price: '£110',
    description: 'For NDS students only - Complete test day support.',
    features: ['Test appointment booking', "Use of instructor's car for test", 'Pre-test warm-up session'],
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }];
  return <div className="bg-gray-50" data-id="element-1305">
      <Helmet data-id="element-1306">
        <title data-id="element-1307">
          Automatic Driving Lessons in Northampton | ⭐⭐⭐⭐⭐ Rated by
          Students| Northampton Driving School
        </title>
        <meta name="description" content="Learn to drive with expert DVSA-approved instructors. Affordable automatic lessons, intensive courses, and refresher training in Northampton. Book today." data-id="element-1308" />
        <meta name="keywords" content="automatic driving lessons Northampton, driving instructor Northampton, intensive driving courses Northampton, refresher driving lessons Northampton, DVSA approved instructors" data-id="element-1309" />
      </Helmet>
      <Hero data-id="element-1310" />
      {/* Trust & Accreditation Strip */}
      <div className="bg-white py-4 border-b border-gray-200" data-id="element-1311">
        <div className="container mx-auto px-4" data-id="element-1312">
          <p className="text-center text-gray-700 font-medium" data-id="element-1313">
            DVSA Approved Instructors | ⭐⭐⭐⭐⭐ Rated by Students | Serving
            Northampton & Surrounding Areas
          </p>
        </div>
      </div>
      {/* Welcome/About Section */}
      <section className="py-12 bg-white" data-id="element-1314">
        <div className="container mx-auto px-4" data-id="element-1315">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1316">
            <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-1317">
              Welcome to <span className="text-burgundy-600" data-id="element-1318">N</span>orthampton{' '}
              <span className="text-burgundy-600" data-id="element-1319">D</span>riving{' '}
              <span className="text-burgundy-600" data-id="element-1320">S</span>chool
            </h2>
            <p className="text-gray-600 mb-6" data-id="element-1321">
              Learning to drive doesn't need to be stressful. With modern
              automatic cars, friendly instructors, and flexible scheduling,
              we'll help you gain confidence from your very first lesson.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 mt-10" data-id="element-1322">
              <div className="bg-white shadow-md rounded-lg overflow-hidden p-2" data-id="element-1323">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2oyjszRjznB9bvy2zh5BXs/Automatic_car.png" alt="Modern automatic car used for driving lessons in Northampton" className="w-full h-40 object-cover rounded" data-id="element-1324" />
                <div className="p-5" data-id="element-1325">
                  <p className="font-medium text-burgundy-800" data-id="element-1326">
                    Automatic Cars Only
                  </p>
                </div>
              </div>
              <div className="bg-white shadow-md rounded-lg overflow-hidden p-2" data-id="element-1327">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jd12Jd7G1HzetPyKCwnF5A/Trsuted_driver.png" alt="DVSA-approved driving instructor teaching student in Northampton" className="w-full h-40 object-cover rounded" data-id="element-1328" />
                <div className="p-5" data-id="element-1329">
                  <p className="font-medium text-burgundy-800" data-id="element-1330">
                    Patient, Qualified Instructors
                  </p>
                </div>
              </div>
              <div className="bg-white shadow-md rounded-lg overflow-hidden p-2" data-id="element-1331">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/p8ENDsD7c9AEgWWLAJNEei/first_time_pass.png" alt="Student celebrating after passing driving test first time in Northampton" className="w-full h-40 object-cover rounded" data-id="element-1332" />
                <div className="p-5" data-id="element-1333">
                  <p className="font-medium text-burgundy-800" data-id="element-1334">
                    High First-time Pass Rates
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Recent Passes */}
      <SuccessStories data-id="element-1335" />
      <TrustBadges data-id="element-1336" />
      {/* Offer Banner with updated styling to match packages */}
      <section className="py-8" data-id="element-1337">
        <div className="container mx-auto px-4" data-id="element-1338">
          <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-8 text-center max-w-3xl mx-auto" data-id="element-1339">
            <h2 className="text-xl md:text-2xl font-bold mb-3" data-id="element-1340">
              First Lesson Only £40 – New Customers Only
            </h2>
            <p className="text-gray-700 mb-5" data-id="element-1341">
              Start with a no-pressure trial session and see why 100s of
              learners trust us.
            </p>
            <a href="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" target="_blank" rel="noopener noreferrer" className="bg-burgundy-600 hover:bg-burgundy-700 text-white px-6 py-3 rounded-md font-medium inline-block transition-colors" data-id="element-1342">
              Book Your Trial Now
            </a>
          </div>
        </div>
      </section>
      {/* Standard Packages Section */}
      <section className="py-12 bg-gray-50" data-id="element-1343">
        <div className="container mx-auto px-4" data-id="element-1344">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-2 text-burgundy-600" data-id="element-1345">
            Standard Lessons
          </h2>
          <h3 className="text-xl md:text-2xl font-bold text-center mb-2" data-id="element-1346">
            Learn at Your Own Pace
          </h3>
          <p className="text-gray-600 text-center mb-8" data-id="element-1347">
            Pick a package that suits your schedule.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1348">
            {standardPackages.map((pkg, index) => <PackageCard key={index} {...pkg} data-id="element-1349" />)}
          </div>
          <div className="text-center mt-8" data-id="element-1350">
            <Link to="/standard-lessons" className="bg-burgundy-600 hover:bg-burgundy-700 text-white px-6 py-3 rounded-md font-medium inline-flex items-center transition-colors" data-id="element-1351">
              View All Standard Lessons{' '}
              <ArrowRight size={16} className="ml-2" data-id="element-1352" />
            </Link>
            <div className="max-w-2xl mx-auto mt-8 bg-white p-6 rounded-lg shadow-md" data-id="element-1353">
              <h4 className="font-bold text-lg mb-2" data-id="element-1354">Standard Lessons</h4>
              <p className="mb-4" data-id="element-1355">
                Learn at your own pace with flexible scheduling. Perfect for
                beginners or those who prefer a gradual learning approach.
              </p>
              <ul className="space-y-2" data-id="element-1356">
                <li className="flex items-start" data-id="element-1357">
                  <Check size={18} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1358" />
                  <span data-id="element-1359">Flexible scheduling</span>
                </li>
                <li className="flex items-start" data-id="element-1360">
                  <Check size={18} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1361" />
                  <span data-id="element-1362">Personalised learning</span>
                </li>
                <li className="flex items-start" data-id="element-1363">
                  <Check size={18} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1364" />
                  <span data-id="element-1365">Discounted packages available</span>
                </li>
                <li className="flex items-start" data-id="element-1366">
                  <Check size={18} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1367" />
                  <span data-id="element-1368">Trial lesson for £40</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Intensive Courses Section */}
      <section className="py-12 bg-white" data-id="element-1369">
        <div className="container mx-auto px-4" data-id="element-1370">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-2 text-burgundy-600" data-id="element-1371">
            Intensive Lessons
          </h2>
          <h3 className="text-xl md:text-2xl font-bold text-center mb-2" data-id="element-1372">
            Pass in Weeks, Not Months
          </h3>
          <p className="text-gray-600 text-center mb-8" data-id="element-1373">
            Fast-track courses designed for learners in a hurry.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-1374">
            {intensivePackages.map((pkg, index) => <PackageCard key={index} {...pkg} data-id="element-1375" />)}
          </div>
          <div className="text-center mt-8" data-id="element-1376">
            <Link to="/intensive-lessons" className="bg-burgundy-600 hover:bg-burgundy-700 text-white px-6 py-3 rounded-md font-medium inline-flex items-center transition-colors" data-id="element-1377">
              Explore Intensive Lessons{' '}
              <ArrowRight size={16} className="ml-2" data-id="element-1378" />
            </Link>
            <div className="max-w-2xl mx-auto mt-8 bg-white p-6 rounded-lg shadow-md" data-id="element-1379">
              <h4 className="font-bold text-lg mb-2" data-id="element-1380">Intensive Courses</h4>
              <p className="mb-4" data-id="element-1381">
                Fast-track your learning with our intensive courses. Perfect for
                those who want to pass their test quickly.
              </p>
              <ul className="space-y-2" data-id="element-1382">
                <li className="flex items-start" data-id="element-1383">
                  <Check size={18} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1384" />
                  <span data-id="element-1385">Pass in weeks, not months</span>
                </li>
                <li className="flex items-start" data-id="element-1386">
                  <Check size={18} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1387" />
                  <span data-id="element-1388">Concentrated learning</span>
                </li>
                <li className="flex items-start" data-id="element-1389">
                  <Check size={18} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1390" />
                  <span data-id="element-1391">Significant cost savings</span>
                </li>
                <li className="flex items-start" data-id="element-1392">
                  <Check size={18} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1393" />
                  <span data-id="element-1394">Courses from 10 to 40 hours</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Additional Lessons Section */}
      <section className="py-12 bg-gray-50" data-id="element-1395">
        <div className="container mx-auto px-4" data-id="element-1396">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-2 text-burgundy-600" data-id="element-1397">
            Additional Lessons
          </h2>
          <h3 className="text-xl md:text-2xl font-bold text-center mb-2" data-id="element-1398">
            Specialised Driving Support
          </h3>
          <p className="text-gray-600 text-center mb-8" data-id="element-1399">
            Additional lessons to enhance your driving skills and confidence.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1400">
            {additionalPackages.map((pkg, index) => <PackageCard key={index} {...pkg} data-id="element-1401" />)}
          </div>
          <div className="text-center mt-8" data-id="element-1402">
            <Link to="/additional-lessons" className="bg-burgundy-600 hover:bg-burgundy-700 text-white px-6 py-3 rounded-md font-medium inline-flex items-center transition-colors" data-id="element-1403">
              View All Additional Lessons{' '}
              <ArrowRight size={16} className="ml-2" data-id="element-1404" />
            </Link>
            <div className="max-w-2xl mx-auto mt-8 bg-white p-6 rounded-lg shadow-md" data-id="element-1405">
              <h4 className="font-bold text-lg mb-2" data-id="element-1406">Additional Lessons</h4>
              <p className="mb-4" data-id="element-1407">
                Specialised lessons to enhance specific skills or build
                confidence in particular areas of driving.
              </p>
              <ul className="space-y-2" data-id="element-1408">
                <li className="flex items-start" data-id="element-1409">
                  <Check size={18} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1410" />
                  <span data-id="element-1411">Refresher driving lessons</span>
                </li>
                <li className="flex items-start" data-id="element-1412">
                  <Check size={18} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1413" />
                  <span data-id="element-1414">Motorway driving lessons</span>
                </li>
                <li className="flex items-start" data-id="element-1415">
                  <Check size={18} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1416" />
                  <span data-id="element-1417">Driving test booking service</span>
                </li>
                <li className="flex items-start" data-id="element-1418">
                  <Check size={18} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1419" />
                  <span data-id="element-1420">Tailored to your specific needs</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Learn To Drive With Us section */}
      <LearnToDriveWithUs data-id="element-1421" />
      {/* Call to Action */}
      <section className="py-16 bg-burgundy-700 text-white" data-id="element-1422">
        <div className="container mx-auto px-4 text-center" data-id="element-1423">
          <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-1424">
            Ready to Get Behind the Wheel? 🚦
          </h2>
          <p className="mb-8 max-w-2xl mx-auto" data-id="element-1425">
            Book your first lesson today and take the first step towards driving
            independence.
          </p>
          <a href="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" target="_blank" rel="noopener noreferrer" className="bg-white text-burgundy-700 hover:bg-gray-100 px-8 py-3 rounded-md font-medium inline-block transition-colors" data-id="element-1426">
            Book Your Trial Now
          </a>
        </div>
      </section>
    </div>;
};
export default HomePage;